export const IntegrationGroup = ({ title, apps }) => {
  return (
    <div className="integrations__integration-group">
      <p className="integrations__group-title">{title}</p>
      <div className="integrations__group-apps">{apps.map((app) => app)}</div>
    </div>
  );
};
